function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("title", null, "tot");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_tote-bag_2947979",
  transform: "translate(-398.000000, 0.000000)",
  fill: "#000000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "tot",
  transform: "translate(398.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17,6 L14.93,6 C14.51,2.61 12,0 9,0 C6,0 3.49,2.61 3.07,6 L1,6 C0.44771525,6 0,6.44771525 0,7 L0,25 C0,25.5522847 0.44771525,26 1,26 L17,26 C17.5522847,26 18,25.5522847 18,25 L18,7 C18,6.44771525 17.5522847,6 17,6 Z M9,2 C10.93,2 12.55,3.72 12.92,6 L5.08,6 C5.45,3.72 7.07,2 9,2 Z",
  id: "Shape"
}))));
const SvgTote = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "26px",
    viewBox: "0 0 18 26",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTote, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tote.fce69a5e.svg";
export { ForwardRef as ReactComponent };